import { Component, Inject, OnInit, ElementRef, Renderer2, OnDestroy, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';
import { BASE_URL } from 'src/app/config/config';

@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class AddMasterProductComponent implements OnInit {
  public propData: any;
  public bodyParts: any;
  public implants: any;
  public categories: any;
  public selectedImplant: any = { id: "", value: "" };
  public selectedBodyPart: any = { id: "", value: "" };
  public selectedCategory: any = { id: "", value: "" };
  public name: string = '';
  public image_name: string = '';
  public code: string = '';
  public isEdited: boolean = false;
  public imageUrl = '';
  public isCategoryDisabled: boolean = false;
  public isBodyPartDisabled: boolean = false;
  public isImplantDisabled: boolean = false;

  public uploadedFile: any = null;
  public uploadedFilePreview: string | ArrayBuffer | null = null;

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {
    if (data) {
      this.propData = data;
      this.bodyParts = this.propData.bodyparts;
      this.implants = this.propData.implants;
      this.categories = this.propData.categories;
    }
  }

  ngOnInit(): void {
    if (this.propData && this.propData.type === "edit") {
      const product = this.propData.item;
      this.selectedCategory = this.categories.find(category => category.id === product.product_category_id);
      this.selectedImplant = this.implants.find(implants => implants.id === product.implant_id);
      this.selectedBodyPart = this.bodyParts.find(bodyParts => bodyParts.id === product.body_part_id);
      this.name = product.name;
      this.code = product.code;
      this.image_name = product.image_name;
      this.imageUrl = this.propData.item.file_path ? 'storage/products/' + this.propData.item.image_name : null;
      this.isEdited = true;
      this.fetchBodyPartsAndImplants(product.id);

      if (this.isEdited && this.propData?.item?.image_name) {
        this.imageUrl = BASE_URL.API_URL + 'storage/products/' + this.propData.item.image_name;
      }
    }
  }

  onCategoryTypeChange(category: any): void {
    this.selectedCategory = category;
    this.fetchBodyPartsAndImplants(this.selectedCategory.id);
    this.isCategoryDropDown.set(false);
    this.isBodyPartDisabled = true;
    this.isImplantDisabled = true;
  }

  fetchBodyPartsAndImplants(id: number) {
    this.masterdataService.getBodyPartsAndImplantsForProduct(id).subscribe((res) => {
      if (res.data) {
        this.selectedImplant = { id: res.data.implant_id, value: res.data.implant_name };
        this.selectedBodyPart = { id: res.data.body_part_id, value: res.data.body_part_name };
      }
    });
  }

  onBodyTypeChange(value: any) {
    this.selectedBodyPart = value;
    this.isBodyPartDropDown.set(false);
    this.isImplantDisabled = false;
  }

  onImplantTypeChange(value: any) {
    this.selectedImplant = value;
    this.isImplantDropDown.set(false);
  }

  onAdd(): void {
      let formData = new FormData();
      formData.append('body_part_id', this.selectedBodyPart.id);
      formData.append('implant_id', this.selectedImplant ? this.selectedImplant.id : null);
      formData.append('product_category_id', this.selectedCategory.id);
      formData.append('name', this.name);
      formData.append('code', this.code);

      if (this.uploadedFile) {
        formData.append('file', this.uploadedFile);  // Append the file to the form data
      }


    if (this.isEdited) {
      formData.append('_method', 'PUT');
      this.masterdataService.masterEditBodyWithFile('products', this.propData.item.id, formData).subscribe((res: any) => {
        this.onClose();
      }, error => {
        console.error("Error editing product:", error);
      });
    } else {
      this.masterdataService.masterAddItemWithFile('products', formData).subscribe((res: any) => {
        this.onClose();
      }, error => {
        console.error("Error adding product:", error);
      });
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.renderer.destroy();
  }

  closeDropdowns() {
    this.isImplantDropDown.set(false);
    this.isBodyPartDropDown.set(false);
    this.isCategoryDropDown.set(false);
  }

  isBodyPartDropDown = signal(false);
  isImplantDropDown = signal(false);
  isCategoryDropDown = signal(false);

  responseData: any = {};
  public fileType = "";
  public isFile = false;
  public statusType: string = "";
  public statusMessage: string = "";

  changedStoreType: any = { type: "", value: "" };
  public isDragOver = signal(false);

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file);
    }
    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);  // Ensure drag-over state is set to true
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);  // Reset drag-over state when drag leaves the drop area
  }

  browseFile(e) {
    e.preventDefault();
    let fileInput = document.getElementById("file-input-add");
    fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

 onFileChange(event) {
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  removeImage(): void {
    this.uploadedFile = null;
    this.uploadedFilePreview = null;
    this.imageUrl = null;

    // Reset file input
    const fileInput = document.getElementById('file-input-add') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }


  fileValidation(file: File) {
  const validFileTypes = ['png', 'jpg'];
  const maxSizeInMB = 5;
  const fileSizeInMB = file.size / (1024 * 1024);

  if (fileSizeInMB > maxSizeInMB) {
    this.statusType = 'error';
    this.statusMessage = `File size exceeds the limit of ${maxSizeInMB}MB.`;
    this.showWarningToast();
    return;
  }

  const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
  if (!validFileTypes.includes(ext)) {
    this.statusType = 'error';
    this.statusMessage = `File format is invalid. Only PNG and JPG formats are allowed.`;
    this.showWarningToast();
    return;
  }

  this.uploadedFile = file;

  const reader = new FileReader();
  reader.onload = () => {
    this.uploadedFilePreview = reader.result;
  };
  reader.readAsDataURL(file);

  this.statusType = 'success';
  this.statusMessage = 'File successfully uploaded!';
  this.showWarningToast();
}


  resetFile() {
    this.isFile = false;
  }

  showWarningToast() {
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function () {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function () {
      toastContainer.classList.remove('show');
    }, 5000);
  }
}
